var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#6851FF",
    fillOpacity: 1,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3631_98586)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83203 3C1.45132 3 0.332031 4.11929 0.332031 5.5V6.2717H24.332V5.5C24.332 4.11929 23.2127 3 21.832 3H2.83203ZM24.332 8.45351H0.332031V17.9545C0.332031 19.3353 1.45132 20.4545 2.83203 20.4545H21.832C23.2127 20.4545 24.332 19.3353 24.332 17.9545V8.45351ZM2.51274 14.9082C2.51274 14.356 2.96045 13.9082 3.51274 13.9082H5.87637C6.42866 13.9082 6.87637 14.356 6.87637 14.9082V17.2719C6.87637 17.8242 6.42866 18.2719 5.87637 18.2719H3.51274C2.96045 18.2719 2.51274 17.8242 2.51274 17.2719V14.9082ZM13.9643 14.4531C13.663 14.4531 13.4188 14.6973 13.4188 14.9986C13.4188 15.2998 13.663 15.544 13.9643 15.544H21.6006C21.9019 15.544 22.1461 15.2998 22.1461 14.9986C22.1461 14.6973 21.9019 14.4531 21.6006 14.4531H13.9643ZM16.6919 17.1803C16.6919 16.8791 16.9361 16.6348 17.2374 16.6348H21.601C21.9023 16.6348 22.1465 16.8791 22.1465 17.1803C22.1465 17.4816 21.9023 17.7258 21.601 17.7258H17.2374C16.9361 17.7258 16.6919 17.4816 16.6919 17.1803Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3631_98586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.332031)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard);
export default __webpack_public_path__ + "static/media/bankCard.5bfa31d050c4467b019dd522d8997268.svg";
export { ForwardRef as ReactComponent };